/**
 * Heat Loss Calculator
 * ===
 * Radiator Model
 * 
 * Extends Backbone Model.
 *
 * Author: Duncan McMillan
 *
 * Copyright (c) August 2024 · Art & Soul Communications Ltd.
 * https://artandsoul.co.uk
 *
 */

'use strict';

import Backbone from 'backbone';

import { HLC_Configs } from './../HeatLossCalculator.Configs.js';

export var RadiatorModel = Backbone.Model.extend({
    
    range: undefined,
    
    initialize: function(attributes, options) {
        
        var that = this;
        
        return this;
    },
    
    isElectric: function() {
        
        if (this.range.has('classification') && this.range.get('classification').name.toLowerCase() === 'electric') {
            return true;
        }
        
        return false;
    },
    
    getOutputCorrectedFor: function(delta_t) {
        
        var correction_key, corrected_output;
        
        if (this.isElectric()) {
            // Delta T is irrelevant
            return Number(this.get('output'));
        }
        
        if (delta_t === undefined) {
            delta_t = HLC_Configs.default_delta_t;
        }
        
        correction_key = Math.round(delta_t / 5);
        
        corrected_output = Math.round(Number(this.get('output')) * HLC_Configs.output_correction_factors[correction_key]);
        
        return corrected_output;
    }
});
